<script lang="ts">
	import { fly } from 'svelte/transition';
	import { Breakpoints, Theme } from '@tools';
	import DatoAsset from '@atoms/DatoAsset.svelte';
	import type { ShowMeWhatData } from '$lib/queries/content/ShowMeWhatQuery';
	import { quartInOut } from 'svelte/easing';

	let { data }: { data: ShowMeWhatData } = $props();

	let genre = $state(data.genres[0]);
	const theme = new Theme(data.colorTheme);

	$effect(() => {
		let index = 0;

		const intervalId = setInterval(() => {
			index++;
			const genreIndex = index % data.genres.length;
			genre = data.genres[genreIndex];
		}, 5000);

		return () => {
			clearInterval(intervalId);
		};
	});
</script>

<section style={theme.css}>
	<div class="graphic">
		{#key genre.asset?.url ?? data.asset.url}
			<div
				class="assetMover"
				in:fly={{
					x: '100%',
					opacity: 1,
					duration: 1000,
					easing: quartInOut
				}}
				out:fly={{
					x: '-100%',
					opacity: 1,
					duration: 1000,
					easing: quartInOut
				}}
			>
				<DatoAsset data={genre.asset ?? data.asset} />
			</div>
		{/key}
		<div class="ovals"></div>
	</div>
	<div class="content">
		<h3 class="text:h2">
			<span>Jeg er mest til</span>
			<br />
			<div class="genre">
				{#key genre.name}
					<span
						in:fly={{
							x: '80px',
							duration: 1000,
							easing: quartInOut
						}}
						out:fly={{
							x: '-80px',
							duration: 1000,
							easing: quartInOut
						}}>{genre.name}</span
					>
				{/key}
			</div>
		</h3>
		<a
			class={Breakpoints.md ? `button:pill` : `button:inverted`}
			href={`/kalender?genres=${genre.slug}`}>Vis mig hvad I har</a
		>
	</div>
</section>

<style lang="scss">
	section {
		display: flex;
		flex-direction: column;
		align-items: stretch;
		background-color: var(--theme-primary);
		aspect-ratio: 1 / #{$ratio1};
		position: relative;
		overflow: hidden;
		@include fullBleedBlock;

		@include md {
			aspect-ratio: 2 / 1;
			flex-direction: row-reverse;
		}
	}

	.graphic {
		position: relative;
		overflow: hidden;
		width: 100%;
		height: 100%;
		z-index: 1;

		@include md {
			flex: 1 0 0;
			aspect-ratio: unset;
		}
	}

	.assetMover {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
	}

	.ovals {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		background: rgba(0, 0, 0, 0.4)
			radial-gradient(closest-side, rgba(0, 0, 0, 0) calc(100% - 1px), var(--theme-secondary) 100%);
		background-repeat: repeat-x;
		background-size: 100% 100%;
		z-index: 2;

		@include md {
			background-size: calc(100% / 2) 100%;
			background-color: transparent;
		}
	}

	.content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: $gap8 $gap2;
		aspect-ratio: 1 / 1.25;
		position: absolute;
		height: 100%;
		width: 100%;
		top: 0;
		left: 0;
		z-index: 2;
		color: $colorBackground;

		@include md {
			color: var(--theme-foreground);
			background: none;
			position: relative;
			flex: 1 0 0;
			aspect-ratio: unset;
		}
	}

	h3 {
		text-align: center;
		text-transform: uppercase;
	}

	.genre {
		height: 1.1em;
		width: 100%;
		position: relative;
		margin-bottom: $gap5;

		span {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
	}
</style>
